import {
  Table,
  TableBodyInfiniteScroll,
  TableHeader
} from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MEMBER_REFERRALS_TABLE_HEADER } from '@bo-constants/member/memberReferrals';
import { MemberReferralRows } from '@bo-components/members/memberReferrals';
import { NoResults } from '@library/components/NoResults';
import { useMemberReferrals } from '@bo-hooks/members/useMemberReferrals';
import { useMemo } from 'react';

export const MemberReferrals = () => {
  const {
    currentPage,
    onCurrentPageChange,
    isError,
    isLoading,
    memberReferrals,
    totalPages
  } = useMemberReferrals();

  const infiniteScrollProps = useMemo(
    () => ({
      dataLength: memberReferrals?.length ?? 0,
      hasMore: totalPages > currentPage,
      loader: <p>Loading...</p>,
      next: onCurrentPageChange
    }),
    [currentPage, memberReferrals, onCurrentPageChange, totalPages]
  );

  if (isLoading && currentPage === 1) {
    return <Loading loadingMessage="" />;
  }

  if (isError) {
    return (
      <section className="p-6">
        <h1 className="text-soClean-100 m-auto text-xl font-bold">
          Error Fetching Member Referrals
        </h1>
      </section>
    );
  }

  if (!memberReferrals.length) {
    return (
      <NoResults
        className="m-0 w-full"
        dataTestId="no-member-referrals"
        label="Currently member does not have any Referrals"
        title="No Referral"
      />
    );
  }

  return (
    <section className="w-full px-6 pt-0">
      <Table className="border-soFresh-140 overflow-x-auto rounded-lg border p-0">
        <TableHeader headers={MEMBER_REFERRALS_TABLE_HEADER} />
        <TableBodyInfiniteScroll
          bodyHeight="[calc(100vh-234px)]"
          bodyMaxHeight="max-h-[calc(100vh-234px)]"
          infiniteScrollProps={infiniteScrollProps}
          scrollId="MemberReferralsTableBody"
        >
          <MemberReferralRows memberReferrals={memberReferrals} />
        </TableBodyInfiniteScroll>
      </Table>
    </section>
  );
};
